import React, { useEffect } from 'react'
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useSelector } from 'react-redux';
import { getRoleBasedView } from '../../actions/Administration/admin.action';
import { useDispatch } from 'react-redux';

const HeatmapApplications = () => {
    const history = useHistory();
    const dispatch = useDispatch();
const RoleBasedView = useSelector((state) => state.adminAccountReducer.RoleBasedView);
            useEffect(() => {
                dispatch(getRoleBasedView())
            }, [dispatch])

     const SubApps = [
        {
            id: 1,
            href: "/heatmapTable",
            name: 'HeatMap Table',
            enable: true,
            isExternal: false,
            visible: RoleBasedView?.[0]?.['HeatMap ReadWrite']?.[0]?.ReadWrite,
        },
        {
            id: 2,
            href: "/heatmapform",
            name: 'HeatMap Form',
            enable: true,
            isExternal: false,
            visible: RoleBasedView?.[0]?.['HeatMap ReadWrite']?.[0]?.ReadWrite,
        },
        {
            id: 3,
            href: "https://app.powerbi.com/groups/d72c9563-5724-4af1-897a-10aa19a17809/reports/dfdd614f-e264-4de5-a482-4c93b3a681e8/eb7299240fa4db97afbf?experience=power-bi",
            name: 'HeatMap Dashboard',
            enable: true,
            isExternal: true,
            visible:RoleBasedView?.[0]?.['HeatMap ReadWrite']?.[0]?.ReadWrite
        },
      
      
       
    ]
  return (
     <div>
    <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={false}  label2='HeatMap'/>
   <div style={{display:'flex',flexWrap:'wrap'}}> {SubApps.map((app, index) => (
        (app.enable && app.visible === 1) ? (
            <div key={index} >
            <div className='App_cards' key={app.id} onClick={() => {
  if (app.isExternal) {
    window.open(app.href, "_blank", "noopener,noreferrer");
  } else {
    history.push(app.href);
  }
}}>
        {app.img ? (
          <img src={app.img} alt='' height='200px' width='200px' />
        ) : (
          <div    style={{
    height: '200px',
    width: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',        // ✅ FIX 1
    padding: '10px',            // ✅ FIX 2
    fontSize: '24px',
    fontWeight: 'bold',
    border: '1px solid #ccc',
    color: '#004aac'
  }}>
            {app.name}
          </div>
        )}
        <div style={{display: 'flex', justifyContent: 'center',color:'#004aac'}}>{app.description}</div>
      </div>
            </div>
        ) : (
            app.visible === 1 && (
                <div key={index} className='aquaaApps_list_disabled'>
                    {app.name}
                </div>
            )
        )
    ))}</div>
</div>
  )
}

export default HeatmapApplications
